/**
 * Role definitions for the application.
 * Each role has an id, name (code used in API), and displayName (user-friendly name for UI)
 */

export interface Role {
  id: number;
  name: string;
  displayName: string;
}

/** Lightweight role shape returned inline on account-svc user responses (name + display only). */
export interface RoleSummary {
  name: string;
  displayName: string;
}

export const ROLES = {
  SYSTEM_API: {
    id: 3,
    name: 'SYSTEM_API',
    displayName: 'System API'
  },
  ACCOUNT_ADMIN: {
    id: 4,
    name: 'ACCOUNT_ADMIN',
    displayName: 'Client Admin'
  },
  ACCOUNT_USER: {
    id: 5,
    name: 'ACCOUNT_USER',
    displayName: 'Client User'
  },
  ACCOUNT_READ_ONLY: {
    id: 6,
    name: 'ACCOUNT_READ_ONLY',
    displayName: 'Client Read-Only'
  },
  SYSTEM_READ_ONLY: {
    id: 7,
    name: 'SYSTEM_READ_ONLY',
    displayName: 'System Read-Only'
  },
  ACCOUNT_API: {
    id: 9,
    name: 'ACCOUNT_API',
    displayName: 'Client API'
  },
  ACCOUNT_API_HXC: {
    id: 10,
    name: 'ACCOUNT_API_HXC',
    displayName: 'HXC Client API'
  },
  SYSTEM_ADMIN_V2: {
    id: 11,
    name: 'SYSTEM_ADMIN_V2',
    displayName: 'System Admin'
  },
  ACCOUNT_ADMIN_V2: {
    id: 12,
    name: 'ACCOUNT_ADMIN_V2',
    displayName: 'Account Admin'
  },
  SOLUTION_ADMIN: {
    id: 13,
    name: 'SOLUTION_ADMIN',
    displayName: 'Solution Admin'
  },
  SE_ADMIN: {
    id: 14,
    name: 'SE_ADMIN',
    displayName: 'Strategy Edge Admin'
  },
  HXC_ADMIN: {
    id: 15,
    name: 'HXC_ADMIN',
    displayName: 'HXC Admin'
  },
  DATA_ADMIN: {
    id: 16,
    name: 'DATA_ADMIN',
    displayName: 'Data Admin'
  },
  SE_READ_ONLY: {
    id: 17,
    name: 'SE_READ_ONLY',
    displayName: 'SE Read Only'
  }
};

/**
 * Find role by name (useful when receiving role from API)
 */
export function getRoleByName(roleName: string): Role | undefined {
  return Object.values(ROLES).find(role => role.name === roleName);
}

/**
 * Find role by id
 */
export function getRoleById(roleId: number): Role | undefined {
  return Object.values(ROLES).find(role => role.id === roleId);
}

/**
 * Get all roles as an array (useful for dropdowns, etc.)
 */
export function getAllRoles(): Role[] {
  return Object.values(ROLES);
}

export default ROLES;